import { render, staticRenderFns } from "./CreateTargetAccountModal.vue?vue&type=template&id=b5f73a44&scoped=true&"
import script from "./CreateTargetAccountModal.vue?vue&type=script&lang=js&"
export * from "./CreateTargetAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f73a44",
  null
  
)

export default component.exports